import { axiosHttp } from "../helper/axiosHttp"


export const signupService=async(data)=>{
   return await axiosHttp.post('/signup',data).then((res)=>{
    return res.data
    }).catch((err)=>{
        return err.response.data;
    });
}
export const loginService=async(data)=>{
    
       return await axiosHttp.post('/login',data).then(async(res)=>{
           console.log(res.data, 'daraResponse')
            return res.data.data
        }).catch((err)=>{
            console.log("error data",err.response);
            return err.response.data;
        });
       
    
}

export const forgetPasswordService=async(data)=>{
    return await axiosHttp.post('/forgot-password',data).then((res)=>{
         return res.data
     }).catch((err)=>{
        return err.response.data;
     });
 }
export const changePasswordService=async(data)=>{
    return await axiosHttp.post('/change-password',data).then((res)=>{
         return res.data
     }).catch((err)=>{
        return err.response.data;
     });
 }
export const restPasswordService=async(data)=>{
    return await axiosHttp.post('/reset-password',data).then((res)=>{
         return res.data
     }).catch((err)=>{
        return err.response.data;
     });
 }